<template>
  <div>
    <slot v-bind="intersectionObserverEntry" />
  </div>
</template>

<script>
const makeOption = (option = {}) => ({
  rootMargin: '0px',
  threshod: 1.0,
  ...option,
});

export default {
  props: {
    options: {
      type: Object,
      default: makeOption,
    },
    handler: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      observer: null,
      intersectionObserverEntry: {
        boundingClientRect: null,
        intersectionRatio: 0,
        intersectionRect: null,
        isIntersecting: false,
        isVisible: false,
        rootBounds: null,
        target: null,
        time: 0,
      },
      isSupported: true,
    };
  },
  computed: {
    intersectionObserverCallbackHandler() {
      return ([entry]) => {
        this.updateInnerState(entry);
        return this.handler(entry, this.isSupported);
      };
    },
  },
  mounted() {
    if (typeof IntersectionObserver === 'undefined') {
      this.isSupported = false;
      this.handler(this.intersectionObserverEntry, this.isSupported);
      return;
    }
    this.updateObserver();
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.unobserve(this.$el);
      this.observer.disconnect();
    }
  },

  methods: {
    updateObserver() {
      this.observer = new IntersectionObserver(this.intersectionObserverCallbackHandler, this.options);
      this.observer.observe(this.$el);
    },

    /**
     * @param {IntersectionObserverEntry} entry
     */
    updateInnerState(entry) {
      this.intersectionObserverEntry = entry;
    },
  },
};
</script>
